var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0318e71daf723897e58c65be0a11976806012daf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rock@rocket-resume"]={id:"0318e71daf723897e58c65be0a11976806012daf"};
      